import{BaseError as t}from"./BaseError";class e extends t{constructor(r){super(r.map(s=>s.toString()).join(`
------
`),{errors:r,translationKey:"multipleErrors"})}static createFromDetails(r,s){return new this(s.errors)}toString(){return this.message}}e._class="MultipleBaseError";export{e as MultipleBaseError};
